import { WPPageData } from '@/types'

export const pageHasHero = (pageProps: WPPageData) =>
  pageProps?.acf?.hero !== undefined

export const pageHasHeroBanner = (pageProps: WPPageData) =>
  pageProps?.acf?.hero?.banner !== undefined &&
  pageProps?.acf?.hero?.banner?.hasBanner &&
  pageProps?.acf?.hero?.banner?.items.length > 0
